import React from 'react';
import { Link } from 'react-router-dom';

// Footer Component
const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white py-8 relative z-10">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          {/* Left Side - Links */}
          <div className="flex flex-wrap gap-4 md:gap-6 justify-center md:justify-start">
            <Link to="/terms" className="text-gray-300 hover:text-white transition-colors">
              Terms & Conditions
            </Link>
            <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link to="/risk-disclaimer" className="text-yellow-300 hover:text-yellow-100 transition-colors font-medium">
              ⚠️ Risk Disclaimer
            </Link>
          </div>

          {/* Right Side - Copyright */}
          <div className="text-gray-300 text-center md:text-right">
            Made with ❤️ in India | Copyright © 2025, TrendVector
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
